import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column'
  },

  tagInputContainer: {
    paddingBottom: '0.75rem'
  },

  inputClass: {
    backgroundColor: '#F5F6F8',
    '&::placeholder': {
      color: '#888888 !important'
    }
  },
  tagList: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    overflow: 'hidden',
    maxHeight: '62px',
    transition: 'max-height 0.3s ease-out',
    '&[aria-expanded="true"]': {
      maxHeight: 'unset',
      transition: `max-height 0.5s cubic-bezier(0, 1, 0, 1)`
    },
    '& > div': {
      marginTop: 2,
      marginBottom: 2
    },
    '& > :not(:last-child)': {
      marginRight: '8px'
    }
  }
}))

export default useStyles
